import React from 'react';
import { SurveySection } from './SurveySection';
import type { SurveyPage as SurveyPageType } from '../../types/surveys/publicSurvey.types';

interface SurveyPageProps {
  page: SurveyPageType;
  primaryColor: string;
}

export const SurveyPage: React.FC<SurveyPageProps> = ({ page, primaryColor }) => {
  return (
    <div className="space-y-6">
      {page.title && (
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-2xl font-semibold text-gray-900">{page.title}</h2>
          {page.description && (
            <div
              className="mt-2 prose prose-sm max-w-none text-gray-700"
              dangerouslySetInnerHTML={{ __html: page.description }}
            />
          )}
        </div>
      )}

      {page.surveySections.map((section) => (
        <SurveySection
          key={section.id}
          section={section}
          primaryColor={primaryColor}
        />
      ))}
    </div>
  );
};